import axios from 'axios';
import { GET_ERRORS, SET_CURRENT_USER, SET_CURRENT_ORGANIZATION } from './types';
import setAuthToken from '../setAuthToken';
import jwt_decode from 'jwt-decode';
const api_url = process.env.REACT_APP_API_URL;

export const registerUser = (user, history) => dispatch => {
    axios.post(api_url+'users/register', user)
            .then(res => history.push('/login'))
            .catch(err => {
                dispatch({
                    type: GET_ERRORS,
                    payload: err.response.data
                });
            });
}

export const loginUser = (user) => dispatch => {
    axios.post(api_url+'users/login', user)
            .then(res => {
                const { token } = res.data;
                // const { organizations } = res.data;
                localStorage.setItem('jwtToken', token);
                setAuthToken(token);
                const decoded = jwt_decode(token);
                dispatch(setCurrentOrg(decoded.organizations[0]));
                dispatch(setCurrentUser(decoded));
            })
            .catch(err => {
                dispatch({
                    type: GET_ERRORS,
                    payload: err.response.data
                });
            });
}

export const setCurrentUser = decoded => {
    return {
        type: SET_CURRENT_USER,
        payload: decoded
    }
}
export const setCurrentOrg = decoded => dispatch => {
    // return {
    //     type: SET_CURRENT_ORGANIZATION,
    //     payload: decoded
    // }
    dispatch({
        type: SET_CURRENT_ORGANIZATION,
        payload: decoded
    });
}

// export const logoutUser = Component => props => {
export const logoutUser = (history) => dispatch => {
    localStorage.removeItem('jwtToken');
    setAuthToken(false);
    dispatch(setCurrentUser({}));
    dispatch(setCurrentOrg(''));
    // history.navigate('/login');
}
